import { useState } from 'react'
import { BookOpenIcon, ShoppingCartIcon, StarIcon } from '@heroicons/react/24/outline'
import { Link } from 'react-router-dom'
import { trackPurchaseClick, trackPreviewDownload, trackCoverFlip, trackEvent } from '../utils/analytics'

export default function BookCallout() {
  const [showBack, setShowBack] = useState(false)

  return (
    <section className="bg-sand py-16">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="text-center">
            <Link 
              to="/book"
              className="block w-full max-w-sm mx-auto rounded-lg overflow-hidden cursor-pointer hover:scale-[1.02] transition-transform" 
              style={{boxShadow: '0 15px 35px rgba(0,0,0,0.25)'}}
            >
              <img 
                src={showBack ? "/back-cover.png" : "/actual-bookcover.png"}
                alt={showBack ? "Indoctri-NATION 365 back cover" : "Indoctri-NATION 365 front cover - Click to learn more"}
                className="w-full h-auto object-contain transition-opacity duration-300"
              />
            </Link>
            <button
              onClick={() => { setShowBack(!showBack); trackCoverFlip(showBack ? 'front' : 'back') }}
              className="text-primary-600 font-semibold text-base hover:text-primary-700 transition-colors mt-3"
            >
              {showBack ? '← View front cover' : 'View back cover →'}
            </button>
          </div>
          <div>
            <h2 className="text-3xl font-bold mb-6">Get the Book</h2>
            <p className="text-lg mb-4 text-neutral-700">
              Indoctri-NATION 365 exposes the history intentionally left out of American education and shows how those omissions shape culture, identity, and power today. It explains how we got here, why it matters, and how responsibility moves from understanding to action.
            </p>
            <p className="text-lg mb-6 text-neutral-700">
              This is a clear, honest guide for understanding systemic racism and engaging with truth, accountability, and action.
            </p>
            <p className="text-lg mb-4 text-neutral-700 font-semibold">
              Inside the book:
            </p>
            <ul className="mb-8 space-y-3">
              <li className="flex items-start gap-3">
                <span className="w-2 h-2 bg-primary-600 rounded-full mt-2 flex-shrink-0" aria-hidden="true"></span>
                <span>Hidden history you were never taught</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-2 h-2 bg-primary-600 rounded-full mt-2 flex-shrink-0" aria-hidden="true"></span>
                <span>How indoctrination shapes beliefs and behavior</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-2 h-2 bg-primary-600 rounded-full mt-2 flex-shrink-0" aria-hidden="true"></span>
                <span>Tools for honest, difficult conversations</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-2 h-2 bg-primary-600 rounded-full mt-2 flex-shrink-0" aria-hidden="true"></span>
                <span>Clear steps toward meaningful change</span>
              </li>
            </ul>
            <a
              href="/PublicSample_INDOCTRINATION_365.pdf"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackPreviewDownload()}
              className="block w-full text-center border-2 border-primary-600 text-primary-600 px-4 py-3 rounded-lg font-semibold hover:bg-primary-50 transition-colors mb-4"
            >
              📖 Download Free Preview
            </a>
            <div className="flex flex-col sm:flex-row gap-4 items-stretch sm:items-start">
              <div className="flex flex-col items-center gap-1 flex-1">
                <a
                  href="https://buy.stripe.com/cNi00i31m971bS3bch6sw02"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => trackPurchaseClick('signed_copy')}
                  className="w-full bg-primary-600 text-white px-4 py-3 rounded-lg font-semibold flex items-center justify-center gap-2 hover:bg-primary-700 transition-colors whitespace-nowrap"
                  aria-label="Buy signed copy directly from the author"
                >
                  <ShoppingCartIcon className="w-5 h-5" aria-hidden="true" />
                  Signed Copy - Discounted
                </a>
                <span className="text-sm text-gray-700 font-semibold">US shipping only - by author</span>
              </div>
              <div className="flex flex-col items-center gap-1 flex-1">
                <a
                  href="https://www.amazon.com/dp/0996043691"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => trackPurchaseClick('amazon')}
                  className="w-full bg-primary-600 text-white px-4 py-3 rounded-lg font-semibold flex items-center justify-center gap-2 hover:bg-primary-700 transition-colors"
                  aria-label="Buy on Amazon"
                >
                  <ShoppingCartIcon className="w-5 h-5" aria-hidden="true" />
                  Buy on Amazon
                </a>
                <span className="text-sm text-gray-700 font-semibold">Available in paperback & Kindle</span>
              </div>
            </div>

            <div className="mt-6 text-center bg-yellow-50 border border-yellow-200 rounded-lg p-4">
              <div className="flex justify-center items-center gap-1 mb-2">
                {[...Array(5)].map((_, i) => (
                  <StarIcon key={i} className="w-5 h-5 text-yellow-400 fill-current" aria-hidden="true" />
                ))}
                <span className="ml-2 text-gray-600">5-star rated on Amazon</span>
              </div>
              <p className="text-gray-700 mb-2 font-medium">If you like it so far…</p>
              <a
                href="https://www.amazon.com/review/create-review/?ie=UTF8&channel=glance-detail&asin=0996043691"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackEvent('review_click', { platform: 'amazon' })}
                className="inline-block bg-yellow-500 text-white px-6 py-3 rounded-lg font-semibold text-lg hover:bg-yellow-600 transition-colors"
              >
                ⭐ Leave a Review on Amazon
              </a>
            </div>
          </div>
        </div>
      </div>

    </section>
  )
}